import styled from '@emotion/styled';
import { Text } from '@pairy/pds-react';

export const MinWidthWrapper = styled.div<{ width: number; height?: number }>`
  min-width: ${({ width }) => width}px;
  ${({ height }) => height && `height: ${height}px;`}
`;

export const CheckBoxInput = styled.input`
  width: 18px;
  height: 18px;
`;

export const KeepAllText = styled(Text)`
  word-break: keep-all;
`;
